module.exports = __webpack_public_path__ + "static/media/aperitivos.796b0f74.jpg";